var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-outline/sparkles"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0841 21.2056L11.9999 25.0005L10.9156 21.2056C10.3461 19.2123 8.78804 17.6543 6.7948 17.0848L2.99988 16.0005L6.7948 14.9162C8.78805 14.3467 10.3461 12.7887 10.9156 10.7954L11.9999 7.00049L13.0841 10.7954C13.6536 12.7887 15.2117 14.3467 17.205 14.9162L20.9999 16.0005L17.205 17.0848C15.2117 17.6543 13.6536 19.2123 13.0841 21.2056Z",
    stroke: "white",
    strokeWidth: 1.81875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.345 11.6199L23.9999 13.0005L23.6547 11.6199C23.2517 10.0076 21.9928 8.74871 20.3805 8.34564L18.9999 8.00049L20.3805 7.65534C21.9928 7.25226 23.2517 5.99339 23.6547 4.3811L23.9999 3.00049L24.345 4.3811C24.7481 5.99339 26.007 7.25226 27.6193 7.65534L28.9999 8.00049L27.6193 8.34564C26.007 8.74871 24.7481 10.0076 24.345 11.6199Z",
    stroke: "white",
    strokeWidth: 1.81875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5255 27.4235L21.9999 29.0005L21.4742 27.4235C21.1756 26.5277 20.4727 25.8248 19.5769 25.5261L17.9999 25.0005L19.5769 24.4748C20.4727 24.1762 21.1756 23.4733 21.4742 22.5775L21.9999 21.0005L22.5255 22.5775C22.8241 23.4733 23.5271 24.1762 24.4229 24.4748L25.9999 25.0005L24.4229 25.5261C23.5271 25.8248 22.8241 26.5277 22.5255 27.4235Z",
    stroke: "white",
    strokeWidth: 1.81875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.4a0a11eb38445d360ce573dbd8f631a6.svg";
export { ForwardRef as ReactComponent };